import { useLang } from '@/i18n';
import EFXQuiet from 'elem/ui-assets/icons/unregular/EFXQuiet';
import EfImg from 'elem/ui/ef-img';
import EfSection from 'elem/ui/ef-section';
import EfSpec from 'elem/ui/ef-spec';
import { useRouter } from 'next/router';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('delta3series');
    const { locale = 'us' } = useRouter();
    const imgAllA = {
        NA: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724678091115/a1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724678091577/b1.jpg',
        },
        EU: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725155029164/euPC1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725155029350/euH1.jpg',
        },
        UK: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725161543987/ukPC1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725161666537/ukH1.jpg',
        },
        AU: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1736751792624/left.jpg',
        },
    };
    const imgLocaleA: any = {
        jp: imgAllA.NA,
        us: imgAllA.NA,
        br: imgAllA.NA,
        mx: imgAllA.NA,
        ca: imgAllA.NA,
        uk: imgAllA.UK,
        eu: imgAllA.EU,
        ph: imgAllA.EU,
        de: imgAllA.EU,
        fr: imgAllA.EU,
        it: imgAllA.EU,
        es: imgAllA.EU,
        nl: imgAllA.EU,
        au: imgAllA.AU,
    };
    const imgA = imgLocaleA[locale] || imgLocaleA['eu'];

    const imgAllB = {
        NA: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724678091372/a2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724678091784/b2.jpg',
        },
        EU: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725155028810/euPC2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725155028971/euH2.jpg',
        },
        UK: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725161543636/ukPC2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725161543808/ukH2.jpg',
        },
        AU: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1736751792808/right.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1736845814995/Frame%201000009035.jpg',
        },
    };
    const imgLocaleB: any = {
        jp: imgAllB.NA,
        us: imgAllB.NA,
        br: imgAllB.NA,
        mx: imgAllB.NA,
        ca: imgAllB.NA,
        uk: imgAllB.UK,
        eu: imgAllB.EU,
        de: imgAllB.EU,
        fr: imgAllB.EU,
        it: imgAllB.EU,
        es: imgAllB.EU,
        nl: imgAllB.EU,
        au: imgAllB.AU,
    };
    const imgB = imgLocaleB[locale] || imgLocaleB['eu'];
    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-m" />
            <div className="logo">
                <EFXQuiet />
            </div>
            <EfSection title={t('NA3_title')} desc={t('NA3_desc')} theme="white" />
            <div className="imgs">
                <div className="img1">
                    <EfImg pc={imgA.pc} h5={imgA.h5} />
                </div>
                <div className="img2">
                    <EfImg pc={imgB.pc} h5={imgB.h5} />
                </div>
            </div>
            <EfSpec className="spec-x" />
        </div>
    );
}
